import React, { useEffect, useState } from 'react'
import { Table, Flex, } from 'antd';
import Main from '../../cpn/Main';
import DeptEdit from './DeptEdit';    
import DeptAdd from './DeptAdd';
import { useBumenListQuery } from '../../store/DianShangYeWuApi';
import classes from '../system.module.css';
function DeptList() {
    const [list, setList] = useState();    
    const qy_id = JSON.parse(localStorage.getItem('jtg-caiwu_qy_id'))
    const qy_name = JSON.parse(localStorage.getItem('jtg-caiwu_qy_name'))   
    const yh_id = JSON.parse(localStorage.getItem('jtg-caiwu_yh_id'))
    const yh_name = JSON.parse(localStorage.getItem('jtg-caiwu_yh_name'))
    const {data, isSuccess} = useBumenListQuery({d_qy_id:qy_id,});
    useEffect(() => {
        if (isSuccess) {
            // console.log(data);
            if(data.Status==='success'){                
                const newArr = data.Result.map(item => {
                    const {d_id:key,d_name,d_cname,d_ctime,d_update_time,d_update_uname} = item;                 
                    return item = {key,d_name,d_cname,d_ctime,d_update_time,d_update_uname}
                }) 
                const sortArr = newArr.sort( (a, b) => {      
                    let aTimeString = a.yh_ctime;
                    let bTimeString = b.yh_ctime;
                    let aTime = new Date(aTimeString).getTime();
                    let bTime = new Date(bTimeString).getTime();
                    return bTime - aTime;     
                    },)
                setList(sortArr)
            }else{
                setList('')
            }
            
        }
    }, [data, isSuccess])
    const columns = [
        {
            key: 'd_name',
            title: '名称',            
            dataIndex: 'd_name',
            render:(text,record) => {
                return<DeptEdit
                    d_id={record.key} 
                    d_name={record.d_name} 
                    qy_id={qy_id}
                    qy_name={qy_name}
                    yh_id={yh_id}
                    yh_name={yh_name}
                    d_ctime={record.d_ctime}
                    d_update_time={record.d_update_time}
                    d_cname={record.d_cname}
                    d_update_uname={record.d_update_uname}
                />
            }
        },              
     
        {
            key: 'key',
            title: '编号',
            dataIndex: 'key',
        },
    ]   
    return (
        <Main selectedKeys={['/DeptList']}>                       
            <Flex align='center' justify='flex-end'>  
                <DeptAdd 
                    qy_id={qy_id}
                    qy_name={qy_name}
                    yh_id={yh_id}
                    yh_name={yh_name}
                />
            </Flex>
            <Table 
                columns={columns} 
                dataSource={list} 
                pagination={{
                    showSizeChanger:true,
                    defaultPageSize:'50',
                    showTotal:(total) => `共${total}条`,
                }} 
                className={classes.customTable}
                style={{marginTop:"10px"}}
                bordered
                size='small'
                rowKey="key"
            />
        </Main>
    )
}

export default DeptList
